export const environment = {
  production: false,
  apiUrl: 'https://yv-api-dev.production.am/api/v1',
  useDemoData: false,
};
